module.exports = __webpack_public_path__ + "img/pastille.4bfac56e.svg";